import RegisterForm from "./RegisterForm";
import { connect } from 'react-redux';
import { useState } from "react";
import GeneralInfo from "./GeneralInfoForm";
import RegisterSuccess from "./registerSuccess";
import OtpForm from "./OtpForm";
import TranslatesContent from "../../../../DataStore/Languages/translatesContent";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { RECAPTCHA_SITEKEY } from "../../../../DataStore/ApiConstant";

const RegisterFormWrapper = ({openGeneralModal}) => {

  // const [formType , setFormType] = useState('generalinfo')
  const [formType , setFormType] = useState('generalinfo')
  const [country , setSelectedCountry] = useState('LK-94')
  const [phone , setPhone] = useState('')

  return (
      <div className="row d-flex justify-content-center">
        <div className="col-11">
         
          <div className="col-12 mainTitel_login"><TranslatesContent contentKey="join"/></div>
          <GoogleReCaptchaProvider reCaptchaKey={RECAPTCHA_SITEKEY}>
            {formType === 'register' ? <RegisterForm setFormType = {setFormType} setSelectedCountry={setSelectedCountry} setPhoneNum={setPhone} /> : 
            formType === 'otpform' ? <OtpForm setFormType = {setFormType} country={country} phone={phone}/> : 
            formType === 'generalinfo' ? <GeneralInfo openGeneralModal={openGeneralModal} setFormType = {setFormType} country={country} phone={phone} /> : <RegisterSuccess openGeneralModal={openGeneralModal}/>}
          </GoogleReCaptchaProvider>
        </div>
      </div>
    
  );
}

// export default RegisterFormWrapper;
const setStatetoProps = (state)=>{
  return {
      LanguageContent : state.SiteLanguages
  }
}
export default connect(setStatetoProps)(RegisterFormWrapper);

